import { useCommandAgents } from "@/hooks/use-command-agents";
import { usePermissions } from "@/context/permissions-context";
import type { CommandAgent } from "@/types/command-agent";

export function useActiveCommandAgent(): {
    activeAgent: CommandAgent | null;
    isLoadingActiveAgent: boolean;
    canListAgents: boolean;
} {
    const { hasAllPermissions } = usePermissions();
    const canListAgents = hasAllPermissions(["LIST_COMMAND_AGENTS"]);
    // The backend's `is_active` query filter is unreliable — fetch the
    // unfiltered list and resolve the active agent client-side instead,
    // same as `/teams/command-team/chat/page.tsx` does.
    const { allAgents, isLoadingAgents } = useCommandAgents();
    const activeAgent = (allAgents.find((a) => a.is_active) ?? null) as CommandAgent | null;

    return {
        activeAgent,
        // Only the genuine first-load state — isFetching also flips true on every
        // silent background refetch (staleTime: 0 here), which would otherwise
        // blank the whole panel out to a loader on every refetch, not just once.
        isLoadingActiveAgent: isLoadingAgents,
        canListAgents,
    };
}
